import { render } from "./PostbackHelp.vue?vue&type=template&id=28d82594&scoped=true&ts=true"
import script from "./PostbackHelp.vue?vue&type=script&lang=ts"
export * from "./PostbackHelp.vue?vue&type=script&lang=ts"

import "./PostbackHelp.vue?vue&type=style&index=0&id=28d82594&lang=scss&scoped=true"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d82594"]])

export default __exports__